import { render } from "./reporting.vue?vue&type=template&id=31794f48&lang=pug"
import script from "./reporting.vue?vue&type=script&lang=js"
export * from "./reporting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__